export default __webpack_public_path__ + "static/image5-e9084fc1c0ee56e1b03fc3f8eb75f3cd.jpg";